import { request } from './request'
const baseUrl = process.env.VUE_APP_BASEURL_USER
// 当前状态
export const isComplete = (params = {}) => {
  const url = '/ocean/api/v1/shop/isExist'
  return request({
    method: 'get',
    url,
    params
  })
}
export const isUserComplete = (params = {}) => {

  const url = '/ocean-bi/system/isExist'
  return request({
    method: 'get',
    url,
    params
  })
}
// 获取当前用户拥有商家的类型
export const getMerchantType = (id) => {
  const url = `${baseUrl}/api/v1/user/ocean/merchant/merchantType/${id}`
  return request({
    method: 'get',
    url
  })
}
const baseURL = process.env.VUE_APP_BURIER
const newapi = process.env.VUE_APP_BASEURL_USER
const biApi = process.env.VUE_APP_BASEURL_BI
export const queryBuried = (data = {}) => {
  const url = baseURL + '/api/v1/portal/statistics/bi-user/action'
  return request({
    method: 'post',
    headers: {
      buried: true
    },
    url,
    data
  })
}
// utm数据上报
export const utmQueryBuried = (data = {}) => {
  const url = baseURL + '/api/v1/portal/statistics/anonymous/action'
  return request({
    method: 'post',
    headers: {
      buried: true
    },
    fileJSON: true,
    url,
    data
  })
}
// 获取套餐状态
export const getComboStatus = (params) => {
  const url = `${newapi}/api/v1/user/accounts/comboStatus`
  return request({
    method: 'get',
    url,
    params
  })
}
// 获取水印详情
export const getWatermark = (params) => {
  const url = biApi + '/watermark/detail'
  return request({
    method: 'get',
    url,
    params
  })
}
// 更新水印
export const postWatermark = (data) => {
  const url = biApi + '/watermark/addOrUpdate'
  return request({
    method: 'post',
    url,
    data
  })
}


// 获取报表设置
export const getReportSetting = (data) => {
  const url = biApi + `/merchantSetting/detail/${data}`
  return request({
    method: 'get',
    url
  })
}

// 更新报表设置
export const postReportSetting = (data) => {
  const url = biApi + '/merchantSetting/addOrUpdate'
  return request({
    method: 'post',
    url,
    data
  })
}

// 获取用户设置
export const getUserSetting = (data) => {
  const url = biApi + `/userSetting/detail/${data}`
  return request({
    method: 'get',
    url
  })
}

// 更新用户设置
export const postUserSetting = (data) => {
  const url = biApi + '/userSetting/addOrUpdate'
  return request({
    method: 'post',
    url,
    data
  })
}

// 企业管理-修改商家名称
export const updateMerchantName = (data) => {
  const url = newapi + '/api/v1/user/ocean/merchant/update/merchant-name'
  return request({
    method: 'post',
    url,
    data
  })
}
// 企业管理-设置是否显示
export const updateIsDisplay = (merchantId, isDisplay) => {
  const url = newapi + `/api/v1/user/ocean/merchant/update/is-display/${merchantId}/${isDisplay}`
  return request({
    method: 'post',
    url,
  })
}
// 企业管理-退出企业
export const quitMerchant = (merchantId) => {
  const url = newapi + `/api/v1/user/permission/authorized/merchant/quit/${merchantId}`
  return request({
    method: 'post',
    url,
  })
}
